import React from 'react';
import { Container, Dropdown } from 'react-bootstrap';

import styles from './../style/Breadcrumbs.module.scss';

const Breadcrumbs = ({ items }) => {
  return (
    <Container className={styles.container}>
      <div className={styles.breadcrumbs}>
        <a href="/">
          <svg 
            width="18" 
            height="18" 
            viewBox="0 0 18 18" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={styles.icon}
          >
            <path d="M6.5165 1.36713L2.02484 4.86713C1.27484 5.45046 0.666504 6.69213 0.666504 7.63379V13.8088C0.666504 15.7421 2.2415 17.3255 4.17484 17.3255H13.8248C15.7582 17.3255 17.3332 15.7421 17.3332 13.8171V7.75046C17.3332 6.74213 16.6582 5.45046 15.8332 4.87546L10.6832 1.26713C9.5165 0.450461 7.6415 0.492128 6.5165 1.36713Z" stroke="black" strokeOpacity="0.6" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 13.9912V11.4912" stroke="black" strokeOpacity="0.6" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
        
        {items.length <= 2 ? (
          items.map((item, index) => (
            <React.Fragment key={index}>
              <span className={styles.separator}>/</span>
              {index === items.length - 1 ? (
                <span className={styles.currentItem}>{item.pagetitle}</span>
              ) : (
                <a href={item.uri} className={styles.item}>{item.pagetitle}</a>
              )}
            </React.Fragment>
          ))
        ) : (
          <>
            {/* First item */}
            <span className={styles.separator}>/</span>
            <a href={items[0].uri} className={styles.item}>{items[0].pagetitle}</a>
            
            {/* Dropdown for middle items */}
            <span className={styles.separator}>/</span>
            <Dropdown className="d-inline">
              <Dropdown.Toggle as="span" className={styles.dropdownToggle}>
                ...
              </Dropdown.Toggle>
              
              <Dropdown.Menu>
                {items.slice(1, -1).map((item, index) => (
                  <Dropdown.Item key={index} href={item.uri}>{item.pagetitle}</Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            
            {/* Last item */}
            <span className={styles.separator}>/</span>
            <span className={styles.currentItem}>{items[items.length - 1].pagetitle}</span>
          </>
        )}
      </div>
    </Container>
  );
};

export default Breadcrumbs;